import { createContext, useContext, type Dispatch, type SetStateAction } from "react";

import type { CampaignTemplate } from "containers/admin/clients/client/campaign-templates-page/campaign-templates-page.types";

type CampaignTemplatesSelection = {
  selectedTemplateIds: string[];
  setSelectedTemplateIds: Dispatch<SetStateAction<string[]>>;
  displayedTemplates: CampaignTemplate[];
  isCurrentPageAllSelected: boolean;
};

/**
 * Selection reaches the checkbox cells through context rather than through the column definitions:
 * `flexRender` mounts a column's `cell` as a component, so a column rebuilt on every selection change
 * remounts every row — and the clicked checkbox loses its ripple mid-animation.
 */
export const CampaignTemplatesSelectionContext = createContext<CampaignTemplatesSelection | null>(
  null,
);

export const useCampaignTemplatesSelection = (): CampaignTemplatesSelection => {
  const selection = useContext(CampaignTemplatesSelectionContext);

  if (!selection) {
    throw new Error("useCampaignTemplatesSelection must be used within CampaignTemplatesPage");
  }

  return selection;
};
